module.exports = __webpack_public_path__ + "static/img/a032.06fb2e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a032.jpg
// module id = 8yqc
// module chunks = 0